/**
 * @flow
 */

import React from 'react';
import { Select } from 'semantic-ui-react';
import { range, map } from 'lodash';
import { format, addMinutes, parse } from 'date-fns';

const setupTimeSpans = () =>
    // 12 hour range with step 30 minutes including end of range
    map(range((12 * 60) / 30 + 1), i => {
        const fmt = 'HH:mm';
        const time = format(addMinutes(parse('8:00', fmt, new Date()), i * 30), fmt);
        return {
            key: i,
            value: time,
            text: time,
        };
    });

const SeminarTime = ({ meta, ...props }) => (
    <Select {...props} options={setupTimeSpans()} />
);

export default SeminarTime;
